export default __webpack_public_path__ + "static/media/Grid3.8.fe1baed8.jpg";